// src/components/lessons/renderers/ChecklistRenderer.jsx
import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';

const ChecklistRenderer = ({ block, isMobile }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
    const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FFFFFF',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem',
          border: '1px solid #E5E7EB'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div style={{
      background: '#FFFFFF',
      borderRadius: '0.75rem',
      padding: isMobile ? '1.25rem' : '1.5rem',
      marginBottom: '1.5rem',
      border: '2px solid #000000',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative corner accent */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '40px',
        height: '40px',
        background: '#3A86FF',
        clipPath: 'polygon(100% 0, 100% 100%, 0 0)',
        opacity: 0.1
      }} />

      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {block.items.map((item, i) => (
          <li
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '0.75rem',
              marginBottom: i === block.items.length - 1 ? 0 : '1rem',
              paddingBottom: i === block.items.length - 1 ? 0 : '1rem',
              borderBottom: i === block.items.length - 1 ? 'none' : '1px solid #E5E7EB',
              transition: 'all 0.2s ease',
              padding: '0.5rem',
              marginLeft: '-0.5rem',
              marginRight: '-0.5rem',
              borderRadius: '0.5rem',
              background: hoveredIndex === i ? '#F9FAFB' : 'transparent',
              cursor: 'default'
            }}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {/* Checkmark Icon */}
            <div style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              background: hoveredIndex === i ? '#000000' : '#3A86FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: hoveredIndex === i ? 'scale(1.1) rotate(12deg)' : 'scale(1) rotate(0deg)'
            }}>
              <CheckCircle style={{
                width: '14px',
                height: '14px',
                color: '#FFFFFF',
                strokeWidth: 3
              }} />
            </div>

            {/* Item Text */}
            <span style={{
              color: '#000000',
              lineHeight: '1.6',
              fontSize: isMobile ? '0.95rem' : '1rem',
              opacity: hoveredIndex === i ? 1 : 0.8,
              transition: 'opacity 0.2s ease',
              fontWeight: hoveredIndex === i ? '500' : '400'
            }}>
               {processText(item)}
            </span>

            {/* Blue accent dot on hover */}
            {hoveredIndex === i && (
              <div style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: '#3A86FF',
                marginLeft: 'auto',
                flexShrink: 0,
                animation: 'pulse 1.5s ease-in-out infinite'
              }} />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChecklistRenderer;